import React, { useRef, useState } from "react";
import Slider from "react-slick";
import styles from './popularProd.module.css';
import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight, Eye, Cpu } from "lucide-react";
import { stripHtmlTags } from "../../../../utils/utils";

const Brand1Slider = ({ prod, manufacturer }) => {
  const totalSlides = prod?.length || 0;
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  const handleBeforeChange = (current, next) => {
    setCurrentSlide(next);
  };

  const handlePrevClick = () => {
    if (sliderRef.current) sliderRef.current.slickPrev();
  };

  const handleNextClick = () => {
    if (sliderRef.current) sliderRef.current.slickNext();
  };

  const sliderSettings = {
    slidesToShow: Math.min(4, prod?.length || 4),
    slidesToScroll: 1,
    speed: 400,
    arrows: false,
    infinite: false,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(3, prod?.length || 3),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, prod?.length || 2),
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className={styles.sliderContainer}>
      <Slider ref={sliderRef} {...sliderSettings} className={styles.slider}>
        {prod?.map((i, idx) => {
          const mfgName = i?.manufacturer?.[0]?.name || manufacturer || "Certified Component";
          const rawDesc = Array.isArray(i?.description) ? i?.description[0] : i?.description;
          const desc = stripHtmlTags(rawDesc) || "High performance electronic component.";

          return (
            <div key={i?._id || idx} className={styles.slideItemWrapper}>
              <div className={styles.prodCard}>
                <div className={styles.cardHeaderTag}>
                  <span className={styles.mfgBadge}>
                    <Cpu size={13} />
                    <span>{mfgName}</span>
                  </span>
                </div>

                <div className={styles.cardImageContainer}>
                  <img
                    src={i?.image}
                    alt={i?.name || "Product"}
                    className={styles.cardImage}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/200x150?text=Component";
                    }}
                  />
                </div>

                <div className={styles.cardBody}>
                  <h4 className={styles.cardTitle} title={i?.name}>
                    {i?.name}
                  </h4>
                  <p className={styles.cardDesc} title={desc}>
                    {desc}
                  </p>
                </div>

                <div className={styles.cardFooter}>
                  <button
                    className={styles.viewCardBtn}
                    onClick={() => navigate(`/ProductCode/${i?.name}`)}
                  >
                    <Eye size={15} />
                    <span>View Component</span>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>

      <div className={styles.footerSect}>
        {/* PROGRESS BAR TRACK */}
        <div className={styles.progressTrackContainer}>
          <div
            className={styles.progressBarFill}
            style={{
              width: `${totalSlides > 0 ? Math.min(100, Math.max(20, ((currentSlide + 1) / Math.max(1, totalSlides - 3)) * 100)) : 100}%`
            }}
          />
        </div>

        {/* NAVIGATION ARROWS */}
        <div className={styles.sliderArrows}>
          <button
            className={`${styles.arrowBtn} ${currentSlide === 0 ? styles.arrowDisabled : ""}`}
            onClick={handlePrevClick}
            disabled={currentSlide === 0}
            aria-label="Previous Slide"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            className={`${styles.arrowBtn} ${styles.arrowNextActive}`}
            onClick={handleNextClick}
            aria-label="Next Slide"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Brand1Slider;
